<template lang="html">
   <div id="app">
      <el-container>
         <el-header class="div-header">
            <Header />
            <el-divider class="header-divider"></el-divider>
         </el-header>
         <div class="main-div">
            <el-container class="main-div parentDiv">
               <splitpanes class="default-theme defaultStyle custom-splite">
                  <pane size="100" class="SideBarLeft">
                     <!--SID1007 Body Part-->
                     <template>
                        <el-container class="SID1007__MailDeliveryList">
                           
                           <div id="SID1007__Container">
                              <el-row class="SID1007__Container__row">
                                 <el-col>
                                    <el-breadcrumb separator-class="el-icon-arrow-right">
                                       <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧) </el-breadcrumb-item>
                                       <el-breadcrumb-item :to="{ path: '' }">メール配信先一覧</el-breadcrumb-item>
                                    </el-breadcrumb>
                                 </el-col>
                              </el-row>
                              <el-row>
                                 <el-form class="EmailDestinationReg" label-width="auto" enctype="multipart/form-data">
                                    <el-form-item >
                                       <span class="mandatoryMark">*</span><span class="spanLabel">メール配信先一括登録</span>
                                      
                                       <el-upload
                                          class="upload-demo"
                                          drag
                                          action="https://jsonplaceholder.typicode.com/posts/"
                                          :auto-upload='false'
                                          ref="upload">
                                          <i class="el-icon-upload"></i>
                                          <div class="el-upload__text">ここにファイルをドロップするか、<em>クリックしてファイルを選択してください。</em></div>
                                        </el-upload>
                                    </el-form-item>
                                    <el-form-item class="ButtonChange">
                                       <el-button type="primary" plain class="RegButton" @click="uploadShow()">登録</el-button>
                                    </el-form-item>
                                    <!--Change CK for backlog ID 1605 csv select error msg-->
                                    <span class="alertSpan">{{ Errortext }}</span>
                                     <!--Change CK for backlog ID 1605 failure part-->
                                 <div title="確認" :visible.sync="dialogTableVisible" class="alertbox_1007">
										<ul>
                                 <li class="ErrorCSV">{{ getresponseMessage }}</li>
											<li v-for="(item,index) in csvuploadErrorList" v-bind:key="index" class="ErrorCSV">{{item}}</li>
										</ul>	
									</div>
                                 </el-form>
                                  
                              </el-row>        
                              <el-row class="SID1007__Container__row">
                                 <el-col>
                                    <div class="MailDeliveryDestinationList">
                                       <div class="labelTitle">メール配信先一覧・個別登録</div>
                                       <el-button class="Output" type="primary" plain @click="downloadcsv()" >CSV出力</el-button>
                                    </div>
                                    <div class="Extraction__Result">
                                       <span class="Extraction__Result__Label">検索</span>
                                    </div>
                                    <el-form class="MailDeliveryInner">
                                       <el-form-item class="MailDeliveryInnerItem2">
                                          <el-form  class="MailDeliveryInline">
                                             <el-form-item label="媒体" class="MailDeliveryInline1">
                                                <el-select v-model="MediaValue" @change="mediaChange($event)" placeholder="">
                                                   <el-option v-for="(item,index) in serviceLinkageDropdown" :key="index" :label="item.label" :value="item.value"></el-option>
                                                </el-select>
                                             </el-form-item>
                                             <el-form-item label="テーマ" class="MailDeliveryInline1">
                                                <el-select v-model="ThemeValue" @change="handleChange($event)" placeholder="">
                                                   <el-option v-for="(item,index) in getTheme" :key="index" :label="item.label" :value="index"></el-option>
                                                </el-select>
                                             </el-form-item>
                                             <el-form-item label="アドレス" class="MailDeliveryInline1">
                                                <el-select v-model="AddressValue" @change="mailChange($event)" placeholder="">
                                                   <el-option v-for="(item,index) in getAddress" :key="index" :label="item.mail_address" :value="item.mail_address"></el-option>
                                                </el-select>
                                             </el-form-item>
                                          </el-form>
                                       </el-form-item>
                                       <el-button id="SelectSearchButton" @click="SearchShow" type="primary" plain>検索</el-button>
                                       <el-row class="TemplateRow"  id="ThemeTable">
                                          <el-button @click="SearchHideprimary" click type="primary" plain>追加</el-button>
                                          <el-button @click="open" click type="danger" plain>削除</el-button>
                                          <el-button @click="SearchHide" click type="info" plain>戻る</el-button>
                                          
                                          <template>
                                             <el-table
                                                v-loading="loading"
                                                ref="multipleTable"
                                                id="TemplateTheme"
                                                border
                                                :data="getTableResult1007"
                                               
                                                @selection-change="handleSelectionChange"
                                                style="width: 100%">
                                                <el-table-column center  type="selection"  width="60"> </el-table-column>
                                                <el-table-column
                                                   prop="data_section"
                                                   label="媒体"
                                                   min-width="150">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="theme_id"
                                                   label="テーマ番号"
                                                   min-width="150">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="theme_name"
                                                   label="テーマ名"
                                                   min-width="350">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="mail_address"
                                                   label="メールアドレス"
                                                   min-width="250">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="template_file_name"
                                                   label="テンプレート"
                                                   min-width="150">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="subject_type"
                                                   label="件名区分"
                                                   min-width="150">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="attach_type"
                                                   label="添付形式"
                                                   min-width="120">
                                                </el-table-column>
                                                <el-table-column
                                                   prop="zero_article_mail"
                                                   label="0件時にメールを送信しない"
                                                   min-width="120">
                                                  
                                                </el-table-column>
                                                <el-table-column
                                                   fixed="left"
                                                   label="編集"
                                                   min-width="120">
                                                   <template slot-scope="scope">
                                                      <el-button type="primary" plain @click.native.prevent="editpage(scope.$index, getTableResult1007,scope.row)">編集</el-button>
                                                   </template>
                                                </el-table-column>
                                             </el-table>
                                          </template>
                                          <el-button @click="SearchHideprimary" type="primary" plain>追加</el-button>
                                          <el-button @click="open" type="danger" plain>削除</el-button>
                                          <el-button @click="SearchHide" type="info" plain>戻る</el-button>
                                          <span class="buttonSpan">{{ text }}</span>
                                       </el-row>
                                    </el-form>
                                 </el-col>
                              </el-row>
                           </div>
                        </el-container>
                     </template>
                     <!--SID1007 Body Part End-->
                  </pane>
                  <pane class="SideBarRight">
                     <SideBar class="SidePane" />
                  </pane>
               </splitpanes>
            </el-container>
         </div>
         <el-container class="footer-div">
            <el-footer class="footer-element">
               <FooterComponent />
            </el-footer>
         </el-container>
      </el-container>
   </div>
</template>

<script lang="js">
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import jsonConst from '../../common/CommonConst.json'
import json from '../../components/config.json';
const newArr = {};
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
  export default  {
   name: 'SID1007',
   components: {
      Header,
      SideBar,
      FooterComponent,
      Splitpanes,
      Pane
   },
   props: [],
   data () {
      return {
         loading: false,
         deletetableload:'',
         userId:'',
         contract_id:'',
         userAuthority:0,
         ShowHideFlag: false, 
         input1: '',
         input2: '',
         text: '',
         MediaValue: ' ',
         ThemeValue: ' ',
         AddressValue: ' ',
         value1: '',
         value2: '',
         Errortext: '',
         upload: '',
         select_option_keyvalue: '',
         select_media_value: '',
         select_mail_address_value: '',
         select_option_keyid: '',
         select_option_theme_id:'',
			select_option_theme_label: '',
         select_option_data_kbn: '',
         serviceLinkageDropdown:[
            {
					value: '',
					label: ''
				}
         ],
         dialogTableVisible: false,
         dialogTableVisiblesuccess:false,
         authority: 0
      }
   },
   computed: {
      ...mapGetters("situation1007", [
         "getTableResult1007",
         "getcheck",
         "getactivename",
         "getmedia",
         "getTheme",
         "getAddress",
         "getDeleteTable",
         "getresponse",
         "getCsvDownloadErrStatus",
         "getCsvDownloadErrmsgDetail",
         "getstatus",
         "getmessage",
         "getData",
         "getresponseMessage",
         "csvuploadErrorList",
         "getuploadrespstatus",
         "getsuccessresponseMessage"
      ]),
      ...mapGetters("situation0001", [
      
			"getUserId",
			"getContractId",
			"getNews_Article_Flag",
			"getMagazine_Article_Flag",
			"getWeb_News_Article_Flag",
			"getUserAuthority",
			"getUserGroupId"
		])
   },
   methods: {
      uploadShow(){
         this.$LogButtonEvent("1007","UploadCSV");
         this.$LogMethodIN("1007","uploadShow");
		if(this.$refs.upload.uploadFiles == 0){
			this.Errortext="CSVファイルを選択してください。";
		}else{
            var fileName = this.$refs.upload.uploadFiles[0]["name"];
            if(fileName.split(".").pop() != 'csv'){//check if file extension is csv
               this.Errortext="CSVファイルを選択してください。";
            }else{
               this.Errortext="";
               var csv_file=this.$refs.upload.uploadFiles[0]["raw"];
               let formData = new FormData();
               formData.append('csv_file', csv_file);
                this.$store.dispatch('communication1007/uploadCsvFile',formData).then(() => {
                  //  Change CK for backlog ID 1605
                   if(this.getuploadrespstatus == 0){
                     this.$alert(this.getsuccessresponseMessage, "確認", {
                  confirmButtonText: 'OK',
				
				})
                   }else{
                      this.dialogTableVisible = true
                   }
                  
                  //Clearing the file after upload
                  this.$refs.upload.uploadFiles = [] 
                  var parameters = {
                     contract_id : this.contract_id,
                     user_authority:this.userAuthority
                  };
                  var parameterstheme = {
                     user_authority:this.userAuthority
                  };
                  var default_details={
                     contract_id: this.contract_id,
                     user_authority: this.userAuthority,
                     user_id: this.userId,
                     theme_flag:0
                  }
                  this.loading=true;
                  this.$store.dispatch('communication1007/showAddress', parameters);
                  this.$store.dispatch('communication1007/showThemeList',parameterstheme);
                  this.$store.dispatch('communication1007/searchDetails',default_details).then(() => {
                  this.loading=false;
                  });
               })
            }
         }
         this.$LogMethodOut("1007","uploadShow");
      },
      handleChange($event){
         this.$LogButtonEvent("1007","SelectTheme");
         this.$LogMethodIN("1007","handleChange");
          //  Change CK for backlog ID 1605
         this.Errortext="";
         this.dialogTableVisible = false;
         //Given Array index as model value since the id has duplicates
			if(this.getTheme.length > 0)
			{
				this.select_option_theme_id = this.getTheme[$event]["value"];
				this.select_option_theme_label = this.getTheme[$event]["label"];
				this.select_option_data_kbn = this.getTheme[$event]["data_kbn"];
			}
         this.$LogMethodOut("1007","handleChange");
      },
      
      mediaChange($event){
         this.$LogButtonEvent("1007","SelectMedia");
         this.$LogMethodIN("1007","mediaChange");
          //  Change CK for backlog ID 1605
         this.Errortext="";
         this.dialogTableVisible = false;
			this.select_media_value = $event;
         this.$LogMethodOut("1007","mediaChange");
      },
      
      mailChange($event){
         this.$LogButtonEvent("1007","SelectMail");
         this.$LogMethodIN("1007","mailChange");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         this.select_mail_address_value = $event;
         this.$LogMethodOut("1007","mailChange");
      },
      
      SearchShow() {
         this.$LogButtonEvent("1007","Search");
         this.$LogMethodIN("1007","SearchShow");
          //  Change CK for backlog ID 1605
         this.Errortext="";
         this.dialogTableVisible = false;
         this.text ="";
         var topics = this.select_option_theme_label;
			var theme_id = this.select_option_theme_id;
			var data_kbn = this.select_option_data_kbn;
			var mail_value = this.select_mail_address_value;
         var media_value = this.select_media_value;
         var searchDetails = {};
			if(media_value != '')
			{
				var dataSection = media_value === "1" ? 1 : media_value == "2" ? 2 : media_value == "5" ? 5 : 0;
				searchDetails.data_section = dataSection;
			}

			if(topics != '')
			{
				if(data_kbn == 1)
				{
               searchDetails.theme_id = theme_id;
				}
				else if(data_kbn == 2)
				{
               searchDetails.theme_group_id = theme_id;
				}
				else if(data_kbn == 3)
				{
               searchDetails.topics_id = theme_id;
            }
            else
            {
               searchDetails.theme_flag = 0;
            }
			}
			else
			{
				searchDetails.theme_flag = 0;
			}
			if(mail_value != '')
			{
				searchDetails.address = mail_value;
         }
         searchDetails.user_id = this.userId;
         searchDetails.user_authority=this.userAuthority;
         this.deletetableload= searchDetails;
         this.loading=true;
         this.$store.dispatch('communication1007/searchDetails', searchDetails).then(()=>{
            this.loading=false;
         });
         this.ShowHideFlag = true;    
         this.$LogMethodOut("1007","SearchShow");    
      },

      SearchHideprimary(){ 
         this.$LogButtonEvent("1007","Add");
         this.$LogMethodIN("1007","SearchHideprimary");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         jsonConst["redirect_path"] = '1008';      
         var prosess_kbn='1';
         
          router.push({
          name: "1008",
          params: {
            prosess_kbn: prosess_kbn
          }
        });
         
       this.$LogMethodOut("1007","SearchHideprimary");  
      },

      editpage(index,rows,row){
         this.$LogButtonEvent("1007","Edit");
         this.$LogMethodIN("1007","editpage");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         var editThemeDetails = {
            contract_id:this.contract_id,
            theme_id: row.theme_id,
            data_kbn: row.data_kbn,
            data_section: row.media_name,
            mail_address_id: row.mail_address_id
         }
         this.$store.dispatch('communication1007/EditTableData',editThemeDetails).then(()=>{
            router.push({
               name: "1008",
               params: {
                  response: this.getresponse,
                  row: row,
                  data_kbn:row.data_kbn,
                  data_section:row.data_section,
                  theme_id : row.theme_id,
                  mail_address_id:row.mail_address_id
               }
            });
         });
         this.$LogMethodOut("1007","editpage");
      },
      SearchHide() {
         this.$LogButtonEvent("1007","Return");
         this.$LogMethodIN("1007","SearchHide");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         jsonConst["redirect_path"] = '1008'; 
         router.push({name:"Home"});
         this.$LogMethodOut("1007","SearchHide");
      },

      open() {
         this.$LogButtonEvent("1007","Delete");
         this.$LogMethodIN("1007","open");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         if(this.$refs.multipleTable.selection.length > 0)
         {
         this.$confirm(json["1007_delete_confirm_message"], json["1007_delete_confirm_message_title"], {
            confirmButtonText: 'OK',
            cancelButtonText: 'キャンセル',
         }).then(() => {
            //code delete table data
               var arrayLength = this.$refs.multipleTable.selection.length;
               var deleteDetails = {};
               var ThemeinfoDeletetableAray = [];
               for(var i=0;i<arrayLength;i++){
                  
                  var theme_id = newArr['value'][i].theme_id;
                  var mail_address = newArr['value'][i].mail_address;
                  var mail_address_id = newArr['value'][i].mail_address_id;
                  var data_section = newArr['value'][i].media_name;
                  var data_kbn = newArr['value'][i].data_kbn;
                  var template_file_id = newArr['value'][i].template_file_id;
                  ThemeinfoDeletetableAray= [...ThemeinfoDeletetableAray,{theme_id:theme_id.toString(),mail_address:mail_address,data_section:data_section,data_kbn:data_kbn,template_file_id:template_file_id, mail_address_id: mail_address_id}]
                  
               }
                  deleteDetails = {
                     contract_id : this.contract_id,
                     delete_info:ThemeinfoDeletetableAray
                  }
               this.$store.dispatch('communication1007/deleteTableData', deleteDetails).then(() => {
                        var status = this.getDeleteTable
                        if(status == 0){
                            
                            this.$alert( "削除に成功しました。", json["1003_delete_toast_title"], {
                                confirmButtonText: 'OK',
                    
                            }).then(()=>{
                              var parameters = {
                                 contract_id : this.contract_id,
                                 user_authority:this.userAuthority
                              };
                              var parameterstheme = {
                                 user_authority:this.userAuthority
                              };
                               this.loading=true;
                               this.$store.dispatch('communication1007/showAddress', parameters);
                               this.$store.dispatch('communication1007/showThemeList',parameterstheme);
                               this.$store.dispatch('communication1007/searchDetails', this.deletetableload).then(() => {
                               this.loading=false;
                               })
                            })
                             
                        }else{
                            this.$alert("削除に失敗しました。", json["1003_delete_failure_title"], {
                                confirmButtonText: 'OK',
                    
                            });
                        }  
                    })
                    .catch((error) => {  
                       console.log(error);
                        this.$alert( json["1003_delete_failure_message"], json["1003_delete_failure_title"], {
                            confirmButtonText: 'OK',
                
                        });
                    });
         })
         }
         else
         {
            this.$alert(json["1007_checkbox_not_check_message"], json["1007_checkbox_not_check_message_title"], {
                        confirmButtonText: 'OK'
               });  
         }
         this.$LogMethodOut("1007","open");
      },

      handleSelectionChange(val){
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         newArr.value=  val;
      
      },

      downloadcsv(){
         this.$LogButtonEvent("1007","CSV");
         this.$LogMethodIN("1007","downloadcsv");
          //  Change CK for backlog ID 1605
         this.dialogTableVisible = false;
         this.Errortext="";
         this.$confirm(json["1007_CSV_download_message"], json["1007_CSV_download_title"], {
               confirmButtonText: 'OK',
               cancelButtonText: 'キャンセル',
               beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {                 
                     done();
                     var mediaselection = this.select_media_value;
                     var topics = this.select_option_theme_label;
                     var theme_id = this.select_option_theme_id;
                     var data_kbn = this.select_option_data_kbn;
                     var mail_value = this.select_mail_address_value;
                     var media_value = this.select_media_value;
                     var credentials={}
                     
                     if(media_value != '')
                     {
                        var dataSection = mediaselection === "1" ? [101] :  mediaselection === "5" ? [5] : [3];
                        credentials.data_section = dataSection;
                     }
                     else
                     {
                        //Data section creation array for csv download AID0083
                        var dataSection_83API = [];
                        //if(this.news_article_flag == true)
                        //{
                           dataSection_83API.push(101);
                        //}

                        //if(this.web_news_article_flag == true)
                        //{
                           dataSection_83API.push(3);
                        //}

                        //if(this.magazine_article_flag == true)
                        //{
                           dataSection_83API.push(5);
                        //}
                        credentials.data_section = dataSection_83API;
                     }
                     if(topics != '')
                     {
                        if(data_kbn == 1)
                        {
                        credentials.theme_id = theme_id;
                        }
                        else if(data_kbn == 2)
                        {
                        credentials.theme_group_id = theme_id;
                        }
                        else
                        {
                        credentials.topics_id = theme_id;
                        }
                     }
                     if(mail_value != '')
                     {
                        credentials.mail_address = mail_value;
                     }

               


             this.$store.dispatch('communication1007/downloadMailDeliveryList',credentials)
             .then(() => {
                  //After the Ajax call finished check if status is error for showing alert
                   var status = this.getCsvDownloadErrStatus;
                   var msgdetail = this.getCsvDownloadErrmsgDetail;
                   if(status == "1")
                   {
                      this.$alert(msgdetail,"更新", {  confirmButtonText: 'OK',  })
                   }
                  else
                   {
                     // console.log("else");
                   }
            });
                  
            } else {            
               done();
            }
            }
         });
         this.$LogMethodOut("1007","downloadcsv");
      }  
   },
   mounted() {
      //For the media dropdown
      var newsSession=this.getNews_Article_Flag;
      var magazineSession=this.getMagazine_Article_Flag;
      var webSession=this.getWeb_News_Article_Flag;

      if(newsSession == true){
         var innerLoopServicenews = {};
         innerLoopServicenews.label="新聞";
         innerLoopServicenews.value="1";
         this.serviceLinkageDropdown.push(innerLoopServicenews);
      }
      if(magazineSession == true){
         var innerLoopServiceMagazine = {};
         innerLoopServiceMagazine.label="雑誌/WEB";
         innerLoopServiceMagazine.value="5";
         this.serviceLinkageDropdown.push(innerLoopServiceMagazine);
      } 
      if(webSession == true){
         var innerLoopServiceWeb = {};
         innerLoopServiceWeb.label="WEB";
         innerLoopServiceWeb.value="2";
         this.serviceLinkageDropdown.push(innerLoopServiceWeb);
      } 
    
      //get the news_article_flag from the session
      this.news_article_flag = this.getNews_Article_Flag
      //get the web_news_article_flag from the session
      this.web_news_article_flag = this.getWeb_News_Article_Flag
      //get the magazine_article_flag from the session
      this.magazine_article_flag = this.getMagazine_Article_Flag

      //get the user id value from session
      this.userId = this.getUserId;

      //get the contract_id value from session
      this.contract_id = this.getContractId;
      //get the user authority value from session
      this.userAuthority =this.getUserAuthority;
      
      jsonConst["redirect_path"] = '1008';
      var parameters = {
         contract_id : this.contractId,
         user_authority:this.userAuthority
      };
      var parameterstheme = {
         user_authority:this.userAuthority
      };
      this.$store.dispatch('communication1007/showAddress', parameters);
      this.$store.dispatch('communication1007/showThemeList',parameterstheme);
      var default_details={
            contract_id: this.contractId,
            user_authority: this.userAuthority,
            user_id: this.userId,
            theme_flag:0
      }
      this.loading=true;
      this.$store.dispatch('communication1007/searchDetails',default_details).then(() => {
         this.loading=false;
      });
      this.deletetableload = default_details
   },
   created(){
      //For the screen Title
     document.title = "メール配信先一覧画面";
   }
}
</script>

<style scoped>
@import "1007.css";
</style>